import { m } from 'framer-motion';

import { Container, Typography, Stack, Grid, alpha, styled } from '@mui/material';

import { MotionViewport, varFade } from '../../components/animate';
import Image from '../../components/Image';

// ----------------------------------------------------------------------

const STATS = [
  {
    stat: 5.1,
    icon: '/assets/Icones/Money.png',
    desc: "Milliards USD de Chiffre d'Affaires réalisé par les entreprises togolaises en 2018",
  },
  {
    stat: 115880,
    icon: '/assets/Icones/Building.png',
    desc: 'Entreprises recensées au Togo en 2018',
  },
  {
    stat: 85,
    icon: '/assets/Icones/togo_and_money.png',
    desc: "(%) de taux de croissance des IDE 2020 par rapport à l'année 2019",
  },
  {
    stat: 1.2,
    icon: '/assets/Icones/Money.png',
    desc: "Milliards USD d'Investissements privés en 2020",
  },
];
const shadowIcon = (color) => `drop-shadow(2px 2px 2px ${alpha(color, 0.48)})`;
// ----------------------------------------------------------------------

const ContentStyle = styled(Stack)(() => ({
  backgroundImage: 'url(/assets/background/Statistique.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export default function HomeStat() {
  return (
    <ContentStyle py={10} mt={5}>
      <Container component={MotionViewport} sx={{ position: 'relative' }}>
        <m.div variants={varFade().inUp}>
          <Typography textAlign="center" variant="h3">
            DES STATISTIQUES QUI DÉMONTRENT
          </Typography>
        </m.div>
        <m.div variants={varFade().inUp}>
          <Typography textAlign="center" variant="h3">
            LES DYNAMISMES D'UNE ÉCONOMIE ÉMERGENTE.
          </Typography>
        </m.div>

        <Grid container sx={{ pt: 10 }} spacing={5}>
          {STATS.map((card) => (
            <Grid key={card.stat} item xs={12} md={3}>
              <Stack position="relative" width={1} spacing={3} alignItems="center">
                <Image
                  src={card.icon}
                  alt={card.stat}
                  sx={{
                    width: 80,
                    height: 80,
                    zIndex: 11,
                    left: 0,
                    right: 0,
                    top: -10,
                    mx: 'auto',
                    position: 'absolute',
                    borderRadius: 10,
                    filter: (theme) => shadowIcon(theme.palette.primary.main),
                  }}
                />
                <Stack sx={{ textAlign: 'center', pt: 6, px: 2, maxWidth: 340 }}>
                  <Typography mb={2} variant="h3" color="#156C53">
                    {card.stat}
                  </Typography>
                  <Typography textAlign="center" fontWeight="bold">
                    {card.desc}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ContentStyle>
  );
}
